import { Box, Fab } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import copy from 'copy-to-clipboard';
import { useSnackbar } from 'notistack';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import adminRoutesConstant from '../../../../constants/adminRoutesConstant';
import { adminPlanOfferFileUploadConstants } from '../../../../constants/formConstants/adminFormConstants';
import { offerListHeadCells, planHeadCells } from '../../../../constants/headCells/masterDataHeadCells';
import { permissionNames } from '../../../../constants/permissions';
import { getAllOfferPlans, updateOfferPlan } from '../../../../services/masterDataService';
import { getOfferCodesByOfferIdentifier, uploadOfferCode } from '../../../../services/plansService';
import { getTableCrudByPermission } from '../../../../utils/other';
import Button from '../../../commons/Button/Button';
import ReloadButton from '../../../commons/Button/ReloadButton';
import GenerateFormHook from '../../../commons/GenerateFormHook';
import AppModal from '../../../commons/Modal/AppModal';
import CircularProgress from '../../../commons/ProgressBar/CircularProgress';
import ScreenWrapper from '../../../commons/ScreenWrapper';
import Table from '../../../commons/Table/dataTable/Table';
import Text from '../../../commons/Text';
import PlanOfferCodesByDate from '../../../layouts/Admin/Plans/PlanOfferCodesByDate';
import UploadOfferExcelButton from '../../../layouts/Admin/Plans/UploadOfferExcelButton';


const AdminPlansDetailsScreen = () => {
    const admin = useSelector(state => state.auth.admin)
    const [data, setData] = React.useState([]);
    const methods = useForm();
    const [showModal, setShowModal] = React.useState(false)
    const [submitButtonIsLoading, setSubmitButtonIsLoading] = React.useState(false)
    const { enqueueSnackbar } = useSnackbar();
    const [selectedPlan, setSelectedPlan] = React.useState(null)
    const [offerCodesList, setOfferCodesList] = React.useState([])

    const handleFormSubmit = (data) => {
        data.file = data.file[0]

        if (!data.file) {
            enqueueSnackbar('Please choose a file before you upload!', {
                variant: 'error'
            })
        }
        else {
            setSubmitButtonIsLoading(true);

            const formData = new FormData()
            formData.set('file', data.file)
            formData.set('jwt', admin.jwt)
            formData.set('name', selectedPlan.name)
            formData.set('offerIdentifier', selectedPlan.offer_identifier)

            uploadOfferCode(formData).then(response => {
                if (response) {
                    if (response.payload) {
                        enqueueSnackbar('File uploaded successfully!', {
                            variant: 'success'
                        })
                        handleCloseModal()
                    }
                }
                else {
                    setSubmitButtonIsLoading(false)
                    enqueueSnackbar('Invalid file! Please upload a valid CSV file.', {
                        variant: 'error'
                    })
                }
            })
        }

    }
    const handleOpenModal = (eachData) => () => {
        setSelectedPlan(eachData)
        setShowModal(true)
        console.log(eachData);
        getOfferCodesByOfferIdentifier(eachData.offer_identifier).then(response => {
            if (response) {
                setOfferCodesList(response.map(offerCode => ({
                    ...offerCode,
                    codeToShow: offerCode.code.slice(0, 5).concat('*******').concat(offerCode.code.slice(offerCode.code.length - 5))
                })))
            }
        })
    }
    const handleCloseModal = () => {
        setSubmitButtonIsLoading(false)
        setShowModal(false)
        setSelectedPlan(null)
        setOfferCodesList([])
    }

    const [loader, setLoader] = React.useState({
        isFetching: false,
        isSuccess: false,
        isFailed: false
    })

    const handleLoadingSuccess = () => {
        setLoader({
            isFetching: false,
            isSuccess: true,
            isFailed: false,
        })
    }

    const handleLoadingFailed = () => {
        setLoader({
            isFetching: false,
            isSuccess: false,
            isFailed: true,
        })
    }

    const handleStartLoading = () => {
        setLoader({
            isFetching: true,
            isSuccess: false,
            isFailed: false,
        })
    }
    const history = useHistory();

    const handleCodeCopyToClipboard = (code) => () => {
        copy(code);
        enqueueSnackbar('Code is copied to clipboard!', {
            variant: 'success'
        })
    }


    const updateData = async (response) => {
        if (response) {
            const plans = []
            for (let i = 0; i < response.length; i++) {
                const plan = response[i];
                try {
                    // const planWiseCustomerResponse = await getPlanWiseCustomer({
                    //     isPaid: 1,
                    //     planId: plan.id
                    // })
                    // if (planWiseCustomerResponse) {
                    //     if (planWiseCustomerResponse) {
                    //         const revenue = plan.planAmount * planWiseCustomerResponse.length
                    //         plan.revenue = formatWithComma.indian(revenue)
                    //     }
                    // }
                    plans.push({
                        ...plan,
                        visibility: plan.is_active ? 'Public' : 'Draft'
                    });
                } catch (error) {
                    console.log(error);
                }
            }
            setData(plans);
            // loading was successfull
            handleLoadingSuccess();
        }
        else {
            // loading was failed
            handleLoadingFailed();
        }
    }

    const goToEditPage = (eachData) => {
        history.push(adminRoutesConstant.adminUrls.AdminPlanEditScreen.url(eachData.plan_id));
    }

    const goToViewPage = (eachData) => {
        history.push(adminRoutesConstant.adminUrls.AdminPlanViewScreen.url(eachData.plan_id));
    }

    const handleDeletePlan = row => {
        delete row.visibility
        updateOfferPlan({
            ...row,
            is_active: 0,
            is_deleted: 1
        }, row.plan_id).then(response => {
            fetchAllPlans();
        })
    }


    const handleAction = (rowData, actionKey) => {

        switch (actionKey) {
            case permissionNames.CAN_READ:
                goToViewPage(rowData);
                return;

            case permissionNames.CAN_UPDATE:
                goToEditPage(rowData);
                return;

            case permissionNames.CAN_DELETE:
                handleDeletePlan(rowData)
                return;
            default:
                return;
        };

    }

    const fetchAllPlans = () => {

        // start the loader
        handleStartLoading();

        getAllOfferPlans().then((response) => {
            updateData(response)
        })
    };

    React.useEffect(() => {
        fetchAllPlans();
    }, [])

    return (
        <ScreenWrapper
            pageTitle="Offers"

            // ? info: To implement create button based on roles, add the below line in ternary operator conditioning
            // admin.permission && admin.permission.Plans && admin.permission.Plans.canCreate == '1'
            ActionComponent={() => (true) ? (
                <Link to={adminRoutesConstant.adminUrls.AdminPlanCreateScreen.url()} style={{ textDecoration: 'none' }}>
                    <Fab size='small' variant="extended" color="primary" aria-label="add">
                        <Add /> Add New Offer
                    </Fab>
                </Link >
            ) : null}
        >
            {
                loader.isFetching && <CircularProgress />
            }
            {
                loader.isSuccess &&
                (
                    data.length > 0 ? (
                        <>
                            <Table
                                tableName='All Offers'
                                headCells={planHeadCells}
                                tableData={data}
                                onClickAction={handleAction}
                                crud={getTableCrudByPermission(admin.permission && admin.permission.Plans)}
                                ActiveComponent={({ eachData }) =>
                                    <UploadOfferExcelButton eachData={eachData} handleOpenModal={handleOpenModal} />
                                }
                            />
                            <Box mt={5}>
                                <PlanOfferCodesByDate plans={data} />
                            </Box>
                        </>
                    ) : <Text variant="h3" ascent="primary">No plans found. Try creating a new admin by clicking the "+" button on top.</Text>
                )
            }
            {
                loader.isFailed && <ReloadButton handleOnClick={fetchAllPlans} />
            }

            <AppModal
                title='Upload offer CSV file'
                open={showModal}
                onClose={() => setShowModal(false)}
                hideClose
                fullWidth
            >
                <Box justifyContent='center' display='flex'>
                    <div style={{
                        width: '25rem'
                    }}>
                        <FormProvider {...methods}>
                            <form onSubmit={methods.handleSubmit(handleFormSubmit)}>
                                <GenerateFormHook control={methods.control} formConstant={adminPlanOfferFileUploadConstants(admin.permission.Plans.canRead == 0)} />
                                <div style={{ marginBottom: '2rem' }}>
                                    <a target='_blank' href='/sample_data.csv'>
                                        <Text fontSize={14} fontWeight={600} style={{ textDecoration: 'underline' }}>Download sample CSV file</Text>
                                    </a>
                                </div>
                                <Button variant='contained' type='submit' color='primary' isLoading={submitButtonIsLoading} fullWidth>{!submitButtonIsLoading ? 'Upload' : 'Uploading File...'}</Button>
                            </form>
                        </FormProvider>
                    </div>
                </Box>
                <Box height={50}></Box>
                <Table
                    tableName='Offer codes'
                    headCells={offerListHeadCells}
                    tableData={offerCodesList}
                    crud={{}}
                    ActiveComponent={({ eachData }) =>
                        <Button style={{ textTransform: 'capitalize' }} color='primary' variant='contained' size='small' onClick={handleCodeCopyToClipboard(eachData.code)}>Copy</Button>
                    }
                />
            </AppModal>
        </ScreenWrapper>
    )
}

export default AdminPlansDetailsScreen
